import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const META = {
  "/": {
    title: "Dr. Devratsinh Parmar — Interventional Cardiologist, Ahmedabad",
    desc: "Advanced cardiovascular care with precision and empathy. Interventional Cardiologist at U.N. Mehta Institute & Director, Godhra Heart & Super Speciality Hospital.",
  },
  "/about": {
    title: "About Dr. Devratsinh Parmar (MBBS, MD, DM Cardiology)",
    desc: "Meet Dr. Devratsinh Parmar — cardiologist and academician managing complex and rare cardiovascular diseases at U.N. Mehta Institute of Cardiology, Ahmedabad.",
  },
  "/services": {
    title: "Cardiac Expertise & Services — Dr. Devratsinh Parmar",
    desc: "Interventional cardiology, EVAR, carotid artery stenting, heart failure, arrhythmia & AICD, and preventive cardiology by Dr. Devratsinh Parmar.",
  },
  "/research": {
    title: "Research & Publications — Dr. Devratsinh Parmar",
    desc: "Peer-reviewed cardiology publications, DOIs and notable case reports by Dr. Devratsinh Parmar, presented at the Cardiological Society of India.",
  },
  "/media": {
    title: "Video & Media — Dr. Devratsinh Parmar",
    desc: "Educational cardiology content including 'Tips & Tricks in Difficult BMV' by Dr. Devratsinh Parmar.",
  },
  "/contact": {
    title: "Contact Dr. Devratsinh Parmar — Cardiologist, Ahmedabad & Godhra",
    desc: "Call +91 90811 02186 or email drdevratsinh21@gmail.com. Available 24/7 for cardiac consultation in Ahmedabad and Godhra, Gujarat.",
  },
};

function setMeta(name, content, attr = "name") {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function RouteMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const m = META[pathname] || META["/"];
    document.title = m.title;
    setMeta("description", m.desc);
    setMeta("og:title", m.title, "property");
    setMeta("og:description", m.desc, "property");
    const url = `https://dr-devratsin-pro.preview.emergentagent.com${pathname}`;
    setMeta("og:url", url, "property");
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [pathname]);
  return null;
}
